import React, {
    Fragment, useCallback, useState, useContext, useRef
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
// TDIC - import removed RedirectAfterLogin from gw-digital-auth-react
import { useAuthentication, AUTH_ERRORS } from 'gw-digital-auth-react';
// TDIC: Do not remove - RedirectAfterLogin taken from new package
import { RedirectAfterLogin } from 'tdic-digital-auth-react';
import { Loader } from '@jutro/components';
// TDIC: error imported
import { error } from '@jutro/logger';
import { isEmpty } from '../LoginUtil';

import messages from './LoginComponent.messages';
import metadata from './LoginComponent.metadata.json5';
import styles from '../CommonLogin.module.scss';

function LoginComponent(props) {
    const {
        onForgotPassword, successPath, loginPath
        // pathAfterSignIn TDIC: this line is removed
    } = props;
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const [loginError, updateLoginError] = useState('');
    // const [isSignInButtonClicked, setSignInButtonClicked] = useState(false);
    // TDIC: this line is removed
    const { login: authLogin, isAuthInProgress } = useAuthentication();
    const signInRef = useRef({});

    const login = useCallback(() => {
        const username = _.get(formData, 'username');
        const password = _.get(formData, 'password');

        if (isEmpty(username) || isEmpty(password)) {
            updateLoginError('fieldEmpty');
            return Promise.resolve();
        }

        updateLoginError(''); // reset errors
        // setSignInButtonClicked(true); TDIC: this line is removed

        return authLogin({
            username: username,
            password: password
        })
            .then(() => {
                // reset errors
                updateLoginError('');
            })
            .catch((err) => {
                // TDIC: LoginComponent error added
                error(`LoginComponent: login - Unable to login ${JSON.stringify(err)}`);
                switch (_.get(err, 'error')) {
                    case AUTH_ERRORS.login_failure: // credentials are wrong
                    case AUTH_ERRORS.notLoggedIn: // tokens check problem
                        updateLoginError('fieldsIncorrect');
                        break;
                    case AUTH_ERRORS.account_locked: {
                        // account is locked
                        updateLoginError('accountLocked');
                        break;
                    }
                    default:
                        updateLoginError('invalidAttempt');
                        break;
                }
            });
    }, [authLogin, formData]);

    const readValue = useCallback(
        (id, path) => {
            return _.get(formData, path);
        },
        [formData]
    );

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    // TDIC: useCallback added
    const handleEnterKey = useCallback(() => {
        signInRef.current.click();
    }, []);
    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    const overrideProps = {
        '@field': {
            onValueChange: writeValue,
            onEnter: handleEnterKey
        },
        signIn: {
            trigger: login,
            innerRef: signInRef
        },
        linkToForgotPassword: {
            visible: !_.isUndefined(onForgotPassword)
        },
        actionsWrapperSingleButton: {
            className: classNames(styles.actionsWrapperSingleButton, {
                [styles.coupleButtonStyle]: !_.isUndefined(onForgotPassword),
                [styles.singleButtonStyle]: _.isUndefined(onForgotPassword)
            })
        },
        errorMsg: {
            content: translator(messages[loginError]),
            visible: !!loginError
        }
    };

    const resolvers = {
        resolveValue: readValue,
        resolveCallbackMap: {
            login: login,
            forgotPassword: onForgotPassword || _.noop
        },
        resolveClassNameMap: styles
    };

    // const successRedirectPath = isSignInButtonClicked ? pathAfterSignIn : successPath;
    // TDIC: this line is removed
    return (
        <Fragment>
            {/* TDIC: successRedirectPathis replaced with successPath */}
            <RedirectAfterLogin successPath={successPath} loginPath={loginPath} />
            {renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers)}
        </Fragment>
    );
}

LoginComponent.propTypes = {
    onForgotPassword: PropTypes.func,
    successPath: PropTypes.string,
    loginPath: PropTypes.string
    // pathAfterSignIn: PropTypes.string TDIC: this line is removed
};

LoginComponent.defaultProps = {
    onForgotPassword: undefined,
    successPath: undefined,
    loginPath: undefined
    // pathAfterSignIn: undefined TDIC: this line is removed
};

export default LoginComponent;
